export default __webpack_public_path__ + "static/media/timesUp.1c5609e2.mp3";